(function () {
  var DRAG_THRESHOLD = 5;

  function initDragScroll(container) {
    if (container.__dragScrollInit) return;
    container.__dragScrollInit = true;

    var isPointerDown = false;
    var isDragging = false;
    var suppressClick = false;
    var startX = 0;
    var startScrollLeft = 0;
    var pointerId = null;

    container.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      isPointerDown = true;
      isDragging = false;
      startX = e.clientX;
      startScrollLeft = container.scrollLeft;
      pointerId = e.pointerId;
    });

    container.addEventListener('pointermove', function (e) {
      if (!isPointerDown || e.pointerId !== pointerId) return;
      var dx = e.clientX - startX;

      if (!isDragging) {
        if (Math.abs(dx) < DRAG_THRESHOLD) return;
        isDragging = true;
        container.classList.add('is-dragging');
        try { container.setPointerCapture(pointerId); } catch (err) {}
      }

      e.preventDefault();
      container.scrollLeft = startScrollLeft - dx;
    });

    function endDrag(e) {
      if (!isPointerDown) return;
      isPointerDown = false;

      if (isDragging) {
        suppressClick = true;
        container.classList.remove('is-dragging');
        try { container.releasePointerCapture(pointerId); } catch (err) {}
      }

      isDragging = false;
      pointerId = null;
    }

    container.addEventListener('pointerup', endDrag);
    container.addEventListener('pointercancel', endDrag);

    // Swallow the click that follows a drag so product links don't open.
    container.addEventListener('click', function (e) {
      if (suppressClick) {
        e.preventDefault();
        e.stopPropagation();
        suppressClick = false;
      }
    }, true);
  }

  function init() {
    document.querySelectorAll('[data-drag-scroll]').forEach(initDragScroll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-scan when Shopify swaps section markup in the Theme Editor.
  document.addEventListener('shopify:section:load', init);
})();
